export const assignUserRolesAdmin = [
  {
    label: "Admin",
  },
  {
    label: "Reporting",
  },
  {
    label: "User",
  },
];

export const assignUserRolesSuperAdmin = [
  {
    label: "Super Admin",
  },
  {
    label: "Admin",
  },
  {
    label: "Reporting",
  },
  {
    label: "User",
  },
];

export const userRolesSuperAdmin = [
  { label: "All users" },
  ...assignUserRolesSuperAdmin
];
export const userRolesAdmin = [ { label: "All users" },...assignUserRolesAdmin];
